<template>
  <div class="mainbody">
    <div id="app" v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>报警管理</el-breadcrumb-item>
          <el-breadcrumb-item>报警列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                v-if="fx_login_companyType == 0"
                type="primary"
                icon="el-icon-view"
                @click="linkUrl"
                >历史数据</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>
              <el-select v-model="cabinetId" placeholder="请选择设备...">
                <el-option :key="0" label="全部设备" :value="0"></el-option>
                <el-option
                  v-for="item in cabinetList"
                  :key="item.id"
                  :label="item.cabinetName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-box">
              <el-input
                placeholder="输入关健字"
                v-model="keyword"
                v-show="false"
              >
              </el-input>
              <el-button
                type="primary"
                slot="append"
                icon="el-icon-search"
                @click="initData"
                style="float: right"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" min-width="150">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>

            <el-table-column label="设备编号" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.cabinetCode }}
              </template>
            </el-table-column>
            <el-table-column
              prop="cabinetName"
              label="设备标签"
            ></el-table-column>

            <el-table-column
              prop="alarmCodeName"
              label="报警名称"
            ></el-table-column>

            <el-table-column
              prop="alarmCode"
              label="故障代码"
            ></el-table-column>

            <el-table-column prop="gmtModified" label="时间"></el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      disabled: false,
      companyId: "",
      cabinetId: "",
      companyList: [],
      cabinetList: [],
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      fx_login_companyType: 0,
    };
  },
  mounted() {
    const _this = this;
    _this.fx_login_companyType = localStorage.getItem("fx_login_companyType");
  },
  methods: {
    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.getCabinetList(_this.companyId);
      }
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/alarm/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      if (_this.keyword.length > 0) {
        sendUrl += "&companyNameLike=" + encodeURI(_this.keyword);
      }

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.cabinetId.length > 0 && _this.cabinetId != 0) {
        sendUrl += "&cabinetId=" + _this.cabinetId;
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          //_this.pageSize = res.data.data.size;
          _this.pageIndex = res.data.data.index;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },

    getCabinetList: function (companyId) {
      let _this = this; //当前页面
      _this.cabinetList = [];
      //加载设备列表
      AxiosAjax({
        url: "/cabinet/cabinet/page?index=1&size=9000&companyId=" + companyId,
        loading: true,
        success: function (res) {
          console.log(res.data.data);
          _this.cabinetList = res.data.data.content;
        },
      });
    },
    //跳转链接
    linkUrl: function () {
      this.$router.push({ name: "AlarmHistoryList" });
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
      this.getCabinetList(this.companyId);
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Alarm/AlarmList.vue